import { assertString } from '#app/lib/assert_types'
import { treq } from '#app/lib/treq'
import { objectKeys } from '#app/lib/utils'
import { pluralize } from '#entities/lib/types/entities_types'
import type { EntityUri, ExtendedEntityType, PluralizedIndexedEntityType, PropertyUri } from '#server/types/entity'

export const allowedValuesPerTypePerProperty = await treq('data', 'get', 'property-values').then(({ values }) => values)

export const propertiesWithValuesShortlists = objectKeys(allowedValuesPerTypePerProperty)

export function getPropertyValuesShortlist ({ type, property }: { type: ExtendedEntityType | PluralizedIndexedEntityType, property: PropertyUri }) {
  assertString(type)
  return allowedValuesPerTypePerProperty[property][pluralize(type)] as EntityUri[]
}
